import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { InterviewPage } from '@/routes/participants/_authenticated/projects/$projectId/-components/interview/interview-page';

/**
 * The AI-moderated interview for an external participant, at
 * `/participants/external/projects/:projectId/interview`. Same page as the
 * participant app's, mounted without its layout; "done" has no project page
 * to return to, so it lands on the thank-you page instead.
 */
export const Route = createFileRoute(
  '/participants/_external/external/projects/$projectId/interview',
)({
  component: ExternalInterviewRoute,
});

function ExternalInterviewRoute() {
  const { projectId } = Route.useParams();
  const navigate = useNavigate();
  const onDone = useCallback(() => {
    void navigate({ to: '/participants/invite/done' });
  }, [navigate]);

  return <InterviewPage projectId={projectId} onDone={onDone} />;
}
